const TEXT_STRING = {
  COMMON: {
    REQUIRE: '必須',
    SOMETHING_WENT_WRONG: '何か問題が発生しました。',
    SOMEONE_WANT_CONTACT: '個別のメッセージができます',
    RECEIVED_MESSAGE: 'さんからメッセージが届きました！',
    TYPING: '誰かが入力しています',
    MESSAGE_REMOVED_CHANNEL: 'グループチャットから削除されました！',
    SESSION_EXPIRED_TITLE: 'セッションの有効時間が切れました',
    SESSION_EXPIRED_MESSAGE: '恐れ入りますが操作をやり直してください',
    LINE_ACCOUNT_CHANGE_MESSAGE:
      'アカウント変更のため、新しいLINEの追加をお願いします',
    LINE_ADD_FRIEND_BUTTON: '友だち追加',
  },
  MESSAGE: {
    INPUT_PLACEHOLDER: 'メッセージを入力...',
    START_MESSAGE: '個別のメッセージができます',
    IMAGE: '「画像」',
    ACTION_LABEL_DEFAULT: 'もっと見る',
    PDF_FILE: 'PDFファイル',
    PDF_OPEN_HINT: 'タップして開く',
    // 送信種別ラベル（management の pdfSent / videoSent と同一文言）
    PDF_SENT: 'PDFを送信しました',
    VIDEO_SENT: '動画を送信しました',
    PDF_UNAVAILABLE: 'このPDFは開けません',
    // 管理画面から届く ZIP のダウンロードカード用（male からの送信は無い）
    ZIP_FILE: 'ZIPファイル',
    ZIP_OPEN_HINT: 'タップしてダウンロード',
    ZIP_UNAVAILABLE: 'このZIPは開けません',
    RECALL: 'メッセージを取り消す',
    RECALL_CONFIRM_TITLE: 'メッセージを取り消す',
    RECALL_CONFIRM_MESSAGE:
      'このメッセージを取り消しますか？相手の画面からは表示されなくなります。',
    RECALL_SUCCESS: 'メッセージを取り消しました',
    RECALL_FAILED: 'メッセージの取り消しに失敗しました',
    DELETE: 'メッセージを取り消す',
    DELETE_CONFIRM_TITLE: 'メッセージを取り消す',
    DELETE_CONFIRM_MESSAGE:
      'このメッセージを取り消しますか？相手の画面からは表示されなくなります。',
    DELETE_SUCCESS: 'メッセージを取り消しました',
    DELETE_FAILED: 'メッセージの取り消しに失敗しました',
    CANCEL: 'キャンセル',
  },
  ERROR: {
    LIMIT_SIZE: '写真は$sizeを超えてはなりません',
    PDF_LIMIT_SIZE: 'PDFは$sizeを超えてはなりません',
    VIDEO_LIMIT_SIZE: '動画は$sizeを超えてはなりません',
    UNSUPPORTED_FILE_TYPE: '画像・動画・PDF以外のファイルは送信できません',
    UPLOAD_FAILED: 'ファイルのアップロードに失敗しました',
    PUBNUB_UUID_NOT_SET: 'PubNub UUIDが設定されていません。ページを更新してください。',
    USER_NOT_FOUND: 'ユーザーが見つかりません。',
    ROOT_ELEMENT_NOT_FOUND: 'ルート要素が見つかりません。',
    CHAT_MANAGEMENT_DISABLED:
      'このプランでは個別チャットをご利用いただけません。',
  },
};

export default TEXT_STRING;
